const STATUS_LABEL = { coming_soon: "Coming soon", active: "Active", pending: "Pending", sold: "Sold", off_market: "Off market" };

/** Job reference/status line, headline, address, description, and the
 * listing-facts panel (beds/baths/sqft/etc) shown at the top of ClientJob. */
export function PropertyHeader({ job, listingFacts }) {
  const p = job.property || {};
  return (
    <div className="mt-10 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-8">
        <div className="flex items-center gap-3">
          <span className="font-mono text-sm">{job.reference}</span>
          {p.status && <span className="text-[11px] font-mono uppercase tracking-[0.1em] px-2.5 py-1 border border-slate-300 text-slate-600">{STATUS_LABEL[p.status] || p.status}</span>}
        </div>
        <h1 className="font-display text-4xl md:text-5xl mt-4">{p.headline || `${job.address.street}, ${job.address.city}`}</h1>
        <p className="text-slate-500 mt-2">{job.address.street}, {job.address.city}, {job.address.state} {job.address.zip}</p>
        {p.description && <p className="text-slate-600 mt-6 leading-relaxed max-w-2xl whitespace-pre-wrap">{p.description}</p>}
      </div>
      {(p.beds || p.baths || p.sqft || p.list_price) && (
        <div className="lg:col-span-4 border border-border p-6 grid grid-cols-2 gap-5 h-fit">
          {listingFacts.map(([l, v]) => (
            <div key={l}><div className="eyebrow">{l}</div><div className="font-display text-2xl mt-1">{v}</div></div>
          ))}
        </div>
      )}
    </div>
  );
}
